import { Button } from '@ui/button'
import { IconCalendar, IconClearClose, IconSelectData, IconUpdatePassword } from '@img/icons'


/** Возвращает кнопку по выбранному типу, для input */
export const getInputButton = (typeButton: 'clear' | 'select' | 'calendar' | 'update', handleButtonClick?: () => void) => {
    switch (typeButton) {
        case 'clear': {
            return <Button size="xs" variant="iconInput" onClick={handleButtonClick}>
                <IconClearClose width='18px' height='18px' />
            </Button>
        }

        case 'select': {
            return <Button size="xs" variant="iconInput" onClick={handleButtonClick}>
                <IconSelectData />
            </Button>
        }

        case 'calendar': {
            return <Button size="xs" variant="iconInput" onClick={handleButtonClick}>
                <IconCalendar />
            </Button>
        }

        case 'update': {
            return <Button size="xs" variant="iconInput" onClick={handleButtonClick}>
                <IconUpdatePassword width='18px' height='18px' />
            </Button>
        }
    }
}